import { render, staticRenderFns } from "./PagePrewWidget.vue?vue&type=template&id=67638b29&scoped=true&"
import script from "./PagePrewWidget.vue?vue&type=script&lang=js&"
export * from "./PagePrewWidget.vue?vue&type=script&lang=js&"
import style0 from "./PagePrewWidget.vue?vue&type=style&index=0&id=67638b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67638b29",
  null
  
)

export default component.exports